module.exports = __webpack_public_path__ + "img/service-xindai3.341dd6c6.svg";